import React, {Component} from 'react'
import {Control, Errors} from 'react-redux-form'
import ArrowButton from '../../../common/button-arrow'
import {Row, Col, FormGroup, ControlLabel, FormControl} from 'react-bootstrap'
import {validators} from "../../../../utils/validators"

class RequiredAutoRedemptionDate extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  render() {

    return (

      <div>

        <Row>
          <Col lg={12} className="autoredemption-date-col">
            <FormGroup controlId="requiredAutoredemptionDate" validationState={this.state['autoredemption_date']}>
              <ControlLabel>Autoredemption dates dd/mm*</ControlLabel>
              <Control
                model='.autoredemption_date'
                validators={{required: validators.required(this.updateErrors, 'autoredemption_date')}}
                placeholder="dd/mm"
                pattern="\d\d/\d\d"
                component={FormControl}/>

              <Errors
                show={{
                  touched: true,
                  focus: false
                }}
                className="errors"
                model='.autoredemption_date'
                messages={{
                  required: 'This field is required',
                  patternMismatch: 'Value does not match the required pattern'
                }}/>
            </FormGroup>

            <ArrowButton className="invisible-button"
                         submit={false}
                         arrow={false}>Delete</ArrowButton>
          </Col>
        </Row>
      </div>
    )
  }
}

export default RequiredAutoRedemptionDate


// WEBPACK FOOTER //
// ./src/components/admin/staff-reward/settings/required-autoredemption-date.jsx